import { Component, OnDestroy, OnInit } from '@angular/core';
import { HelperProvider } from '../providers/helper.provider';
import { Page } from '../model/page';
import { Irsaliye } from '../model/irsaliye';
import { ActivatedRoute, Router } from '@angular/router';
import { Master } from '../model/master';
import { Subscription } from 'rxjs';
import { RestService } from '../providers/rest.service';
import { ParaBirimiTutar } from '../teklif/teklif.component';
import { IrsaliyeOlusturRequest } from '../model/irsaliye-olustur-request';
import { AuthService } from 'src/auth/auth.service';

@Component({
  selector: 'app-irsaliye',
  templateUrl: './irsaliye.component.html',
  styleUrls: ['./irsaliye.component.css']
})
export class IrsaliyeComponent implements OnInit, OnDestroy {

  id: number = null;

  totalTutarText = '';
  paraBirimleri: Master[] = null;
  private subscriptions: Subscription[] = [];
  irsaliye: Irsaliye = null;
  userGrupId: number;

  constructor(private restService: RestService,
    private route: ActivatedRoute,
    private router: Router,
    private helperProvider: HelperProvider,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.userGrupId = this.authService.getUser().kullaniciGrupId;
    this.helperProvider.currentPage$.next(Page.Irsaliyeler);
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.id = Number(params.id);
        this.getIrsaliye();
      } else {
        this.router.navigate(['404']);
        return;
      }
      this.getParaBirimleri();
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  toplamTutarHesapla() {
    const array: ParaBirimiTutar[] = [];
    if (this.paraBirimleri) {
      for (const pb of this.paraBirimleri) {
        array.push(new ParaBirimiTutar(pb, 0));
      }
    }

    for (const t of this.irsaliye.irsaliyeKalemler) {
      const index = array.findIndex(x => x.paraBirimi.id === t.paraBirimiId);
      if (index !== -1) {
        array[index].tutar += t.tutar * t.adet;
      }
    }

    const textArray = [];
    for (const e of array) {
      if (e.tutar !== 0) {
        textArray.push(`${e.tutar.toLocaleString('tr-TR')} ${e.paraBirimi.aciklama}`);
      }
    }
    this.totalTutarText = textArray.join(' + ');
  }

  getParaBirimleri() {
    const types = [
      Master.ParaBirimi
    ];
    this.restService.getMasterTypes(types).subscribe(res => {
      if (res) {
        this.paraBirimleri = res.ParaBirimi?.map(x => new Master(x));
      }
    });
  }

  private getIrsaliye() {
    this.restService.irsaliye(this.id).subscribe(res => {
      if (res) {
        this.irsaliye = res;
        this.toplamTutarHesapla();
      } else {
        this.router.navigate(['404']);
      }
    });
  }

  save() {
    const request = new IrsaliyeOlusturRequest();
    request.id = this.irsaliye.id;
    request.irsaliyeNo = this.irsaliye.irsaliyeNo;
    request.irsaliyeNotu = this.irsaliye.irsaliyeNotu;
    request.irsaliyeTarihi = this.irsaliye.irsaliyeTarihi;
    request.siparisId = this.irsaliye.siparisId;
    request.irsaliyeKalemler = this.irsaliye.irsaliyeKalemler;

    this.restService.irsaliyeKaydet(request).subscribe(res => {
      this.router.navigate(['irsaliyeler']);
    });
  }
}
